<template>
  <section class="business posire">
    <ChooseAuditUser ref="chooseAudioUser" @change="handleAuditChange" :customShow="true" />
    <!-- 左侧内容 -->
    <section class="content">
      <table class="table">
        <!-- 表格title -->
        <tr class="titleBox">
          <td class="primary">审核级别</td>
          <td class="primary posire">
            一级审核
            <img class="rightArrow posiab" src="~images/right.png" />
          </td>
          <td class="posire primary">
            二级审核
            <img class="rightArrow posiab" src="~images/right.png" />
          </td>
          <td class="posire primary">
            三级审核
            <img class="rightArrow posiab" src="~images/right.png" />
          </td>
          <td class="posire primary">
            四级审核
            <img class="rightArrow posiab" src="~images/right.png" />
          </td>
          <td class="posire primary">五级审核</td>
        </tr>
        <!-- 表格title end -->
        <template v-for="(item) in auditList">
          <tr
            class="listBox"
            :key="item.auditCode + 'other'"
            v-if="item.auditCode === '300003' || item.auditCode === '22000090'"
          >
            <!-- 标题 -->
            <td
              class="posire"
              :class="{primary: activeAudit === item.auditCode}"
              :rowspan="item.auditCode === '300003' || item.auditCode === '22000090' ? 2 : 1"
            >
              {{item.auditName}}
              <input class="focusInput posiab" :ref="item.auditCode" />
            </td>
            <!-- 标题 end -->
            <!-- 订单价格审核 -->
            <td class="editInputBox" colspan="5" v-if="item.auditCode === '300003'">
              <section>
                审核条件：运费超出运费上限
                <el-input
                  class="inputBox"
                  v-model="ruleData.exceedGuidePrice"
                  @change="handleRuleChange(item)"
                >
                  <span slot="suffix" class="inputUnit">%</span>
                </el-input>需审核
              </section>
              <section>
                <el-checkbox
                  class="orderCheckbox"
                  v-model="ruleData.isHigherPrepayment"
                  @change="handleRuleChange(item)"
                >高于预付标准需审核</el-checkbox>
                <el-checkbox
                  class="orderCheckbox"
                  v-model="ruleData.isHigherOil"
                  @change="handleRuleChange(item)"
                >高于油卡标准需审核</el-checkbox>
                <el-checkbox
                  class="orderCheckbox"
                  v-model="ruleData.isLowerOil"
                  @change="handleRuleChange(item)"
                >低于油卡标准需审核</el-checkbox>
                <el-checkbox
                  class="orderCheckbox"
                  v-model="ruleData.isHigherEtc"
                  @change="handleRuleChange(item)"
                >高于ETC标准需审核</el-checkbox>
                <el-checkbox
                  class="orderCheckbox"
                  v-model="ruleData.isLowerEtc"
                  @change="handleRuleChange(item)"
                >低于ETC标准需审核</el-checkbox>
              </section>
            </td>
            <!-- 订单价格审核 end -->
            <!-- ETC记录手动匹配 -->
            <td class="editInputBox" colspan="5" v-if="item.auditCode === '22000090'">
              审核条件：ETC消费记录手动匹配审批的起点金额
              <el-input
                class="inputBox"
                v-model="ruleData.etcMatchAmt"
                @change="handleRuleChange(item)"
              >
                <span slot="suffix" class="inputUnit">元</span>
              </el-input>
            </td>
            <!-- ETC记录手动匹配 end -->
          </tr>
          <tr class="listBox" :key="item.auditCode">
            <!-- 标题 -->
            <td
              class="posire"
              :class="{primary: activeAudit === item.auditCode}"
              v-if="item.auditCode !== '300003' && item.auditCode !== '22000090'"
            >
              {{item.auditName}}
              <input class="focusInput posiab" :ref="item.auditCode" />
            </td>
            <!-- 标题 end -->
            <td class="posire" v-for="i in 5" :key="i">
              <section v-if="item.auditNodes && item.auditNodes[i - 1]">
                <p class="label">
                  <span v-if="i=== 1">一</span>
                  <span v-if="i=== 2">二</span>
                  <span v-if="i=== 3">三</span>
                  <span v-if="i=== 4">四</span>
                  <span v-if="i=== 5">五</span>
                  级审核人员
                </p>
                <p class="auditUser">{{handleShowUser(item.auditNodes[i - 1])}}</p>
                <p class="textRight btnBox posiab">
                  <span class="error cur btn" @click="remove(item, i - 1)">删除</span>
                  <span class="primary cur btn" @click="showUserDialog(item, i - 1)">修改</span>
                </p>
              </section>
              <!-- 添加按钮 -->
              <section
                class="addBtnBox cur primary"
                v-else
                @click="showUserDialog(item, i-1)"
                v-show="i === 1 || (item.auditNodes && item.auditNodes[i - 2])"
              >
                <i class="iconfont addBtn">&#xe6ab;</i>
              </section>
              <!-- 添加按钮 end -->
            </td>
          </tr>
        </template>
      </table>
    </section>
    <!-- 左侧内容 end -->
    <!-- 右侧导航 -->
    <section class="rightNav posifix">
      <qx-card title="选择事项">
        <section
          class="navItem posire cur"
          v-for="(item, index) in auditList"
          :key="index"
          @click="jumpAudit(item)"
        >
          <article
            class="logoBox posiab"
            :class="{
              first: index === 0,
              last: index === auditList.length - 1,
            }"
          >
            <img class="posire" v-show="activeAudit !== item.auditCode" src="~images/radio.png" />
            <img
              class="posire"
              v-show="activeAudit === item.auditCode"
              src="~images/radioActive.png"
            />
          </article>
          {{item.auditName}}
        </section>
      </qx-card>
    </section>
    <!-- 右侧导航 end -->
  </section>
</template>

<script>
import {
  businessApproveList,
  baseApproveEdit,
  baseApproveRemove,
  businessApproveRule,
  businessApproveRuleEdit,
} from 'api/system';
import ChooseAuditUser from 'components/chooseAuditUser/chooseAuditUser';
export default {
  components: {
    ChooseAuditUser,
  },
  data () {
    return {
      ruleDataTmpl: '{}',
      ruleData: {
        etcMatchAmt: '', // etc审批起点金额
        exceedGuidePrice: '', // 订单 - 运费上限
        isHigherPrepayment: false, // 高于预付标准需审核
        isHigherOil: false, // 高于油卡标准需审核
        isLowerOil: false, // 低于油卡标准需审核
        isHigherEtc: false, // 高于ETC标准需审核
        isLowerEtc: false, // 低于ETC标准需审核
      },
      activeAudit: '',
      auditList: [],
    };
  },
  methods: {
    showUserDialog (editData, index) {
      this.editData = {
        ...editData,
        tarIndex: index,
      };
      let data = [];
      if (index !== undefined) {
        if (editData.auditNodes && editData.auditNodes[index] && editData.auditNodes[index].list) {
          data = editData.auditNodes[index].list.map((item) => ({
            linkman: item.userName,
            mobilePhone: item.userBill,
            userId: item.userId,
            orgNames: item.orgNames,
          }));
        }
      }
      this.$refs.chooseAudioUser.show(data);
    },
    async handleAuditChange (result) {
      const targetObjId = result.map((item) => item.userId);
      this.editData.auditNodes = this.editData.auditNodes === null || this.editData.auditNodes === undefined ? [{nodeId: -1}] : this.editData.auditNodes;
      const parentNode = this.editData.auditNodes[this.editData.tarIndex - 1];
      const params = {
        // 取上一级的 nodeId
        parentNodeId: parentNode ? parentNode.nodeId : -1,
        auditCode: this.editData.auditCode,
        targetObjId: targetObjId.join(','),
        targetObjType: 2,
      };
      // 如果是修改，则要填写当前项的 nodeId，而新增不用
      if (this.editData.auditNodes[this.editData.tarIndex]) {
        params.nodeId = this.editData.tarIndex || this.editData.tarIndex === 0 ? this.editData.auditNodes[this.editData.tarIndex].nodeId : -1;
      }
      const res = await baseApproveEdit(params);
      if (!res.failed) {
        this.$message.success('修改成功');
        this.getData();
      }
    },
    async remove (item, index) {
      const confirmRes = await this.$confirm('确认要移除该流程节点吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await baseApproveRemove({
          nodeId: item.auditNodes[index].nodeId,
        });
        if (!res.failed) {
          this.$message.success('移除成功');
          this.getData();
        }
      }
    },
    async getData () {
      const res = await businessApproveList();
      this.auditList = Array.isArray(res) ? res : (Array.isArray(res && res.items) ? res.items : []);
    },
    async getFuleData () {
      this.ruleData = await businessApproveRule({
        auditCode: '300003,22000090',
      });
      this.ruleDataTmpl = JSON.stringify(this.ruleData);
    },
    async handleRuleChange (item) {
      if (!(item.auditNodes && item.auditNodes[0])) {
        this.$message.warning('请先设置审核节点');
        this.ruleData = JSON.parse(this.ruleDataTmpl);
        return;
      }
      const confirmRes = await this.$confirm('是否确认保存设置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
        this.ruleData = JSON.parse(this.ruleDataTmpl);
      });
      if (confirmRes === 'confirm') {
        const res = await businessApproveRuleEdit({
          auditCode: item.auditNodes[0].auditCode,
          nodeId: item.auditNodes[0].nodeId,
          ...this.ruleData,
        });
        if (!res.failed) {
          this.$message.success('保存成功');
          this.getFuleData();
        } else {
          this.ruleData = JSON.parse(this.ruleDataTmpl);
        }
      }
    },
    jumpAudit (item) {
      this.activeAudit = item.auditCode;
      const auditRef = this.$refs[item.auditCode];
      if (auditRef && auditRef[0] && auditRef[0].focus) {
        auditRef[0].focus();
      }
    },
    handleShowUser (item) {
      if (item && Array.isArray(item.list)) {
        const arrUser = item.list.map((item) => item.userName);
        return arrUser.join('，');
      } else {
        return '--';
      }
    },
  },
  created () {
    this.getData();
    this.getFuleData();
  },
};
</script>

<style scoped lang="scss">
.business {
  padding-right: 244px;
  .content {
    // 中间内容
    background: #fff;
    .table {
      width: 100%;
      td {
        width: 16.66%;
        box-sizing: border-box;
      }
    }
    .titleBox {
      background: #fafafa;
      height: 48px;
      line-height: 48px;
      padding-left: 24px;
      box-sizing: border-box;
      text-align: center;
      .rightArrow {
        width: 16px;
        height: 16px;
        top: 16px;
        right: -8px;
      }
    }
    .listBox {
      td {
        padding: 16px 16px 30px;
        border-bottom: 1px solid #e0e0e0;
        border-right: 1px solid #e0e0e0;
        .label {
          color: #999;
          margin-bottom: 16px;
        }
        .focusInput {
          // 右侧nav用的input
          left: -20000px;
        }
        .auditUser {
          // 审核人员
          margin-bottom: 16px;
        }
        .addBtnBox {
          // 添加按钮
          padding-top: 14px;
          text-align: center;
          .addBtn {
            font-size: 40px;
          }
        }
        .btnBox {
          // 修改删除按钮
          bottom: 16px;
          right: 16px;
          .btn {
            margin-left: 16px;
          }
        }
      }
      .orderCheckbox {
        margin-top: 8px;
      }
      .editInputBox {
        padding: 16px;
        .inputBox {
          width: 160px;
          margin-left: 8px;
        }
      }
    }
  }
  .rightNav {
    // 右侧导航
    width: 240px;
    height: 80%;
    top: 104px;
    right: 0;
    box-sizing: border-box;
    overflow-y: auto;
    .navItem {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #e0e0e0;
      margin-left: 32px;
    }
    .navItem:last-child {
      border-bottom: none;
    }
    .logoBox {
      width: 1px;
      background: #e0e0e0;
      bottom: 0;
      left: -22px;
      img {
        width: 16px;
        height: 16px;
        left: -7px;
      }
    }
    .first {
      height: 20px;
      img {
        top: -16px;
      }
    }
    .last {
      height: 20px;
      bottom: 20px;
    }
  }
}
</style>
